import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IItemSuggestion, IMasterData, ISearchLabels, ItemSearchCritera, ItemSuggestion } from 'src/app/core/models';
import { ItemService } from 'src/app/core/services/item.service';
import { PriceBookService } from 'src/app/core/services/price-book.service';
import { DiscountStoreService } from '../../../services/discount-store.service';
import { LanguageTranslationService } from '../../../services/language-translation.service';
import { MasterDataService } from '../../../services/master-data.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  headerSearchTxt: ISearchLabels;
  constructor(
    private itemService: ItemService,
    private masterDataService: MasterDataService,
    private discountStoreService: DiscountStoreService,
    private router: Router, private languageTranslation: LanguageTranslationService
  ) { }

  
  //#region Control Text
  search = {
    searchCatalogLbl : 'Search Catalog',
    categoryPickLbl : 'Pick a Category',
    advancedSearchLbl: 'Advanced Search',
    availPriceBookCategoriesLbl: 'Available Pricebook Categories',
    noItemMatchLbl:'No items match'
  }
  
  
  
  //#endregion
  public filteredItems: IItemSuggestion[];
  public currentInputValueInItemSearch: string;
  //public itemSearchLoading: BehaviorSubject<boolean> = new BehaviorSubject(
  //  false
  //);
  searchingItem: boolean = false;
  public filteredCategories: string[];
  public searchForm: FormGroup = new FormGroup({
    selectedCategory: new FormControl(-1),
    selectedItem: new FormControl(''),
  });

  public priceBookCategories: IMasterData[];
  pbData: IMasterData[];
  selectedCategory: number = -1;
  showSuggestionBox: boolean;
  selectedItem = '';

  public subscription: Subscription;
  showclearance: boolean = false;
  async ngOnInit() {
    this.loadLanguageTranslationData();
    this.itemService.searchCriteria = new ItemSearchCritera();
    //#region GetPriceBook Categories
    this.priceBookCategories = await this.masterDataService.getPriceBookCategories();
    this.pbData = this.priceBookCategories.slice();
    this.subscription = this.itemService.ResetSearchForm.subscribe(hasChange => {
      if (hasChange) {
        this.resetSearchForm();
      }
    })
    try {
      this.showclearance = await this.discountStoreService.getDealFlag().toPromise();
    }
    catch (e) {
      this.showclearance = false;
    }
  }
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "searchCatalogLbl" },
      { controlName: "categoryPickLbl" },
      { controlName: "advancedSearchLbl" },
      { controlName: "availPriceBookCategoriesLbl" },
      { controlName: "noItemMatchLbl" },      
    ];
    const componentName = "headerSearch";
    const response = this.languageTranslation.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.headerSearchTxt = response[response.length - 1];
    } else {
      this.headerSearchTxt =undefined;
    }
  }

  //#endregion
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  //#region Search Functions


  splitText(eachItem: string) {
    if (this.currentInputValueInItemSearch.length === 1) {
      return eachItem.split('');
    }
    const regexString: string =
      this.currentInputValueInItemSearch +
      '|[^' +
      this.currentInputValueInItemSearch +
      ']|[0-9]|[a-z]';
    const regexConstructor: RegExp = new RegExp(regexString, 'gi');
    return eachItem.match(regexConstructor);
  }
  isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }
  handleItemFilter(searchQuery: string) {
    if (!this.isEmptyOrSpaces(searchQuery) && searchQuery.length > 0) {
      searchQuery = searchQuery.toUpperCase();
      this.showSuggestionBox = false;
      this.searchingItem = true;
      this.currentInputValueInItemSearch = searchQuery;
      this.itemService.getItemSuggestions({
        searchstring: searchQuery,
        categoryId: this.selectedCategory,
        customerNumber: "",
        countryCode : ""
      }).subscribe((data: ItemSuggestion[]) => {
        this.filteredItems = data;
        this.searchingItem = false;
        this.showSuggestionBox = true;
      });
    } else {
      this.showSuggestionBox = false;
      this.itemService.searchCriteria.searchQuery = '';
      this.itemService.searchCriteria.itemNumber = '';
    }
  }
  handleCategoryFilter(category: string) {
    // this.selectedCategory = category
  }
  handlePriceBookCategorySelection(event) {
    // console.log('2');
    if (event) {
      //console.log(event);
      this.selectedCategory = +event.value;
      this.itemService.searchCriteria.categoryId = +event.value;
    } else {
      this.selectedCategory = -1;
      this.itemService.searchCriteria.categoryId = -1;
    }
    this.selectedItem = '';
    this.itemService.searchCriteria.searchQuery = "";
    this.itemService.searchCriteria.itemNumber = "";
  }
  itemSelected(event) {
    console.log(event);
    if (!this.isEmptyOrSpaces(event)) {
      const item = this.filteredItems.find(x => x.fullDescription === event);
      this.itemService.searchCriteria = new ItemSearchCritera();
      if (item && item.itemNumber) {
        this.itemService.searchCriteria.itemNumber = item.itemNumber;
      } else {
        this.itemService.searchCriteria.searchQuery = event;
      }

      const selectedCategory = this.searchForm.controls.selectedCategory.value
      if (selectedCategory) {
        this.itemService.searchCriteria.categoryId = +selectedCategory;
      }
    }

  }
  public handlePriceBookCategoryFilter(event) {
    // console.log(1);
    this.pbData = this.priceBookCategories.filter(
      (s) => s.name.toLowerCase().indexOf(event.toLowerCase()) !== -1
    );
  }
  //#endregion

  gotoDiscountStore(routepath: string): void {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([routepath]); // navigate to same route
    });
  }

  gotoAdvancedSearch(routepath: string): void {
    this.itemService.searchCriteria = new ItemSearchCritera();
    // it will clear the selected category and item selected field
    this.resetSearchForm();
    this.setTCategoryIds();
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([routepath]); // navigate to same route
    });
  }

  gotoSearchResult(routepath: string): void {
    if (!this.itemService.searchCriteria) {
      this.itemService.searchCriteria = new ItemSearchCritera();
    }
    this.itemService.searchCriteria.searchQuery = this.currentInputValueInItemSearch;
    console.log(this.currentInputValueInItemSearch);
    this.setTCategoryIds();
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([routepath]); // navigate to same route
    });
  }
  setTCategoryIds() {
    if (this.itemService.searchCriteria.categoryId < 0) {
      this.itemService.searchCriteria.allCategoryIds = [];
      this.priceBookCategories.forEach((el, index) => {
        this.itemService.searchCriteria.allCategoryIds.push(+el.value);
      })
    }
  }
  resetSearchForm() {
    this.selectedCategory = -1;
    this.selectedItem = '';
    this.itemService.searchCriteria = new ItemSearchCritera();
    this.searchForm.controls.selectedCategory.reset();
    this.searchForm.controls.selectedItem.reset();
  }
}
